import React, { ReactElement } from 'react';

import { QueryRouteProps } from './QueryRoute';
import { useQueryRouter } from './QueryRouter';

interface QuerySwitchProps {
  children: ReactElement<QueryRouteProps>[];
}

export const QuerySwitch = ({ children }: QuerySwitchProps) => {
  const { has } = useQueryRouter();

  return children.find(({ props: { query } }) => !query || (query && has(query))) || null;
};
